import React from 'react';
import { t } from "../locale";

interface NationalityDropdownProps {
  selectedNationality: string;
  passport: string,
  disabled: boolean,
  invalid?: boolean,
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const NationalityDropdown: React.FC<NationalityDropdownProps> = ({
  selectedNationality,
  onChange,
  passport,
  disabled,
  invalid
}) => {
  // Osnovna lista zemalja
  const countries = [
    t('Germany'),
    t('Switzerland'),
    t('Austria'),
    t('Australia'),
    t('UnitedKingdomofGreatBritainandNorthernIreland'),
    t('UnitedStatesofAmerica'),
    t('France'),
    t('Italy'),
    t('Albania'),
    t('Belgium'),
    t('Bosnia and Herzegovina'),
    t('Brazil'),
    t('Bulgaria'),
    t('Montenegro'),
    t('Canada'),
    t('China'),
    t('Czech Republic'),
    t('Denmark'),
    t('Estonia'),
    t('Finland'),
    t('Greece'),
    t('Georgia'),
    t('Netherlands'),
    t('Croatia'),
    t('Ireland'),
    t('Israel'),
    t('Iraq'),
    t('Iran'),
    t('India'),
    t('Kosovo'),
    t('Latvia'),
    t('Lithuania'),
    t('Luxembourg'),
    t('Hungary'),
    t('Moldova'),
    t('Mexio'),
    t('Norway'),
    t('Pakistan'),
    t('Poland'),
    t('Portugal'),
    t('Romania'),
    t('North Macedonia'),
    t('Spain'),
    t('Serbia'),
    t('Slovakia'),
    t('Slovenia'),
    t('Sweden'),
    t('UnitedArabEmirates'),
    t('Україна')
  ];

  const idCardNationalities = [
    "Germany", "Switzerland", "Austria", "aus", "United Kingdom", "United States", "fra", "ita", "shqiptare/albanian", "bel", "bih/бих",
    "bra", "българия/bgr", "mne", "canadian/canadienne", "chn", "česká republika", "dnk", "est", "fin",
    "ελληνικΗ/hellenic", "geo", "nederlandse", "hrv", "éireannach/irish", "Israel", "irq", "Iran", "ind", "kosovar", "latvijas",
    "lietuvos respublikos", "lux", "hun", "mda", "mex", "norsk/norwegian", "pak", "polskie", "prt", "rou",
    "македонско/macedonian", "esp", "Serbia", "svk", "si",
    "svensk/swe", "are", "Ukraine"
  ];

  const passportNationalities = [
    "Germany", "Switzerland", "Austria", "aus", "United Kingdom", "United States", "fra", "ita", "shqiptare/albanian", "bel", "bih/бих",
    "bra", "българия/bgr", "mne", "canadian/canadienne", "chn", "česká republika", "dnk", "est", "fin",
    "ελληνικΗ/hellenic", "geo", "nederlandse", "hrv", "IRL", "Israel", "irq", "Iran", "ind", "kosovar", "latvijas",
    "lietuvos respublikos", "lux", "hun", "mda", "mex", "norsk/norwegian", "pak", "polskie", "prt", "rou",
    "македонско/macedonian", "esp", "Serbia", "svk", "si",
    "svensk/swe", "are", "Ukraine"
  ];

  const nationalities = countries.map((country, i) => ({
    country,
    nationality: passport === "true" ? passportNationalities[i] : idCardNationalities[i]
  }));

  return (
    <select
      disabled={disabled}
      id="nationality"
      className={`form-control ${invalid ? 'border-warning border-2' : 'border-primary'}`}
      value={selectedNationality}
      onChange={onChange}
      required={true}
    >
      <option value="">{t('selectNationality')}</option>
      {nationalities.map((item, index) => (
        <option key={index} value={item.nationality}>
          {item.country}
        </option>
      ))}
    </select>
  );
};

export default NationalityDropdown;